<template>
  <div>
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.pos')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card mar-to-15">
          <div class="card-content">

            <!-- FILTERS -->
            <div class="table-top" style="display: flex; justify-content: space-between; align-items: flex-end; gap: 10px; flex-wrap: nowrap; margin-bottom: 20px;">

              <!-- LEFT: FILTERS -->
              <div class="left-group" style="display: flex; flex-wrap: nowrap; gap: 8px; align-items: flex-end; flex: 0 1 auto;">

                <!-- MAP ID -->
                <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                  <label>{{ $t('catalogProd.id') }}</label>
                  <el-input
                    v-model="searchId"
                    :placeholder="$t('catalogProd.id')"
                    size="small"
                    clearable
                  />
                </div>

                <!-- NAME -->
                <div class="form-group" style="flex: 0 0 180px; margin: 0;">
                  <label>{{ $t('catalogProd.name') }}</label>
                  <el-input
                    v-model="search"
                    :placeholder="$t('catalogProd.name')"
                    size="small"
                    clearable
                  />
                </div>

                <!-- LOCATION -->
                <div class="form-group" v-if="locations.length" style="flex: 0 0 200px; margin: 0;">
                  <label>{{ $t('orders.location') }}</label>
                  <el-select
                    v-model="selectedLocations"
                    :placeholder="$t('general.select')"
                    size="small"
                    multiple
                    collapse-tags
                    clearable
                    style="width: 100%;">
                    <el-option
                      v-for="loc in locations"
                      :key="loc.id || loc.true_id"
                      :label="loc.name"
                      :value="loc.true_id || loc.id">
                    </el-option>
                  </el-select>
                </div>

                <!-- SEARCH BUTTON -->
                <div class="form-group" style="flex: 0 0 100px; margin: 0;">
                  <button class="btn add" @click="searchMaps" :title="$t('reports.search')" style="width: 100%; font-size: 12px; padding: 4px 8px;">
                    <i class="ti-search"></i> {{ $t('general.search') }}
                  </button>
                </div>

              </div>

              <!-- RIGHT: ADD BUTTON -->
              <div class="right-group" style="flex: 0 0 auto;">
                <button class="btn add" @click.prevent="goToAdd" :title="$t('general.add')" style="font-size: 12px; padding: 4px 8px;">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </div>

            </div>

            <data-tables
              v-loading="loading"
              :data="tableData"
              :search-def="{}"
              :pagination-def="{}"
              :table-props="{'border': false}"
              style="width: 100%">

              <!-- Define your table columns -->
              <el-table-column
                min-width="10"
                prop="name"
                label="ID">
                <template slot-scope="props">
                  <div class="cell-center">{{ props.row.id || '-' }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="name"
                label="Name">
                <template slot-scope="props">
                    <div class="cell-center">{{ props.row.name ? props.row.name : "-" }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="30"
                prop="name"
                label="Location">
                <template slot-scope="props">
                    <div class="cell-center">{{ props.row.location.name ? props.row.location.name : "-" }}</div>
                </template>
              </el-table-column>

              <el-table-column
                :width="320"
                :label="$t('general.actions')">
                <template slot-scope="props">
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('marketingCampaigns.send')"
                    @click="handleDelete(props.row.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                  <div class="edit" @click="goToRecord(props.row, $event, props.row)">
                    <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import swal from 'sweetalert2'
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
import 'sweetalert2/dist/sweetalert2.css'

export default {
  components: {
    // GeneralTopBar
  },
  created () {
    this.locations = this.$session.get('selectedCompanyData').locations_details || []
    this.getData()

    this.$bus.$on('refresh', this.handleRefresh)
  },
  data () {
    return {
      loading: true,
      tableData: [],
      search: '',
      searchId: '',
      selectedLocations: [],
      locations: []
    }
  },
  // mounted () {
  //   this.$bus.$on('refresh', this.handleRefresh)
  // },
  beforeDestroy () {
    this.$bus.$off('refresh', this.handleRefresh)
  },
  methods: {
    handleRefresh () {
      this.getData()
    },
    goToRecord (row, event, column) {
      // this.$router.push('/screens/kds/edit/' + row.id)

      if (typeof this.callback === 'function') {
        this.callback(row.id)
      } else {
        this.globalGoToRecord(row, event, column, '/pos/map/')
      }
    },
    goToAdd () {
      this.$router.push('/pos/map/add')
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    getData () {
      const data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }

      // Add filters
      if (this.searchId) {
        data.id = this.searchId
      }
      if (this.search) {
        data.search = this.search
      }
      if (Array.isArray(this.selectedLocations) && this.selectedLocations.length) {
        data.location_ids = this.selectedLocations
      }

      this.apiRequest('/pos/all/map', 'GET', data, response => {
        if (response.status === true) {
          this.tableData = response.data.table_maps
        }
        this.$nextTick(() => {
          this.loading = false
        })
      })
    },
    searchMaps () {
      this.getData()
    },
    handleDelete (item) {
      var btnCounter = 3
      swal({
        text: this.$t('addOrder.areYouSureDelete'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('marketingFidelities.yes') + ' (' + btnCounter + ')'
      })
      .then((result) => {
        if (result) {
          const data = {
            id: item,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/pos/map/' + item, 'DELETE', data, (response) => {
            if (response.status === true) {
              swal(
                '',
                this.$t('general.success'),
                'success'
              )
              this.getData()
            } else {
              swal(
                '',
                response.errors['id'] ? response.errors['id'] : this.$t('validations.wentWrong'),
                'error'
              )
            }
          })
          // }
        }
      })
      .catch((err) => {
        if (err) {
        }
      })
      swal.disableConfirmButton()
      const yes = this.$t('general.yes')
      const btnInterval = setInterval(() => {
        btnCounter--
        if (btnCounter >= 1) {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = `${yes} (${btnCounter})`
          }
        } else {
          if (swal.getConfirmButton()) {
            swal.getConfirmButton().textContent = yes
          }
          clearInterval(btnInterval)
          swal.enableConfirmButton()
        }
      }, 1000)
    }
  }
}
</script>

<style>
  td.error-spelling-fix-position textarea.label-notification-textarea {
    resize: vertical !important;
    overflow: hidden !important;
    min-height: auto !important;
  }

  .delivery_method{
    display: flex;
    flex-direction: column;
  }
  .delivery_method_points{
    display: flex;
    align-items: center;
    gap: 30px;
    margin-bottom: 10px;
  }

  .delivery_method_points :first-child {
    width: 300px;
  }

  .loyaltyPointsModal__footer {
    text-align: end;
  }

  .loyaltyModal {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PosSettings/PosMapList.vue